import { useState } from "react";
import CustomRadio from "shared/components/radio/CustomRadio";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import {
  formatarDataString,
  formatarDataStringParaMesAno,
  formatarValorMonetario,
} from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { RegistroContaPagarTabelaGroupPay } from "types/contasPagar/RegistroContaPagarTabelaGroupPay";

interface RenderRowsTabelaModalVincularDespesasGroupPayProps {
  registros: RegistroContaPagarTabelaGroupPay[];
  onSelecionarDespesa: (registro: RegistroContaPagarTabelaGroupPay) => void;
}

const RenderRowsTabelaModalVincularDespesasGroupPay: React.FC<RenderRowsTabelaModalVincularDespesasGroupPayProps> = (
  props
) => {
  const [idRegistroSelecionado, setIdRegistroSelecionado] = useState<number>();

  const renderRegistros = () => {
    if (props.registros) {
      return props.registros.map((registro: RegistroContaPagarTabelaGroupPay, index) => {
        return (
          <LinhaTabela
            id={`id-condominio-integrado-group-pay-${index}`}
            key={`key-condominio-integrado-group-pay-${index}`}
            isSelecionada={idRegistroSelecionado === registro.id}
          >
            <RegistroTabela
              id={`checkbox-vincular-despesa-group-pay-${index}`}
              key={`key-checkbox-vincular-despesa-group-pay-${index}`}
            >
              <CustomRadio
                checked={idRegistroSelecionado === registro.id}
                onClick={() => {
                  setIdRegistroSelecionado(registro.id);
                  props.onSelecionarDespesa(registro);
                }}
                value={undefined}
                size="small"
              />
            </RegistroTabela>

            <RegistroTabela
              id={`classe-conta-vincular-despesa-group-pay${index}`}
              key={`key-classe-conta-vincular-despesa-group-pay${index}`}
            >
              <span>{registro.descricaoClasseConta}</span>
            </RegistroTabela>

            <RegistroTabela
              id={`fornecedor-vincular-despesa-group-pay${index}`}
              key={`key-fornecedor-vincular-despesa-group-pay-${index}`}
            >
              <div>{registro.nomeFornecedor}</div>
            </RegistroTabela>

            <RegistroTabela
              id={`competencia-vincular-despesa-group-pay-${index}`}
              key={`key-competencia-vincular-despesa-group-pay-${index}`}
            >
              {formatarDataStringParaMesAno(registro.mesCompetencia)}
            </RegistroTabela>

            <RegistroTabela
              id={`numero-documento-vincular-despesa-group-pay-${index}`}
              key={`key-numero-documento-vincular-despesa-group-pay-${index}`}
            >
              <>{registro.numeroDocumento ? registro.numeroDocumento : "-"}</>
            </RegistroTabela>

            <RegistroTabela
              id={`seu-data-vencimento-vincular-despesa-group-pay-${index}`}
              key={`key-data-vencimento-vincular-despesa-group-pay-${index}`}
            >
              {formatarDataString(registro.dataVencimento)}
            </RegistroTabela>
            <RegistroTabela
              id={`seu-numero-vincular-despesa-group-pay-${index}`}
              key={`key-seu-numero-vincular-despesa-group-pay-${index}`}
            >
              <>{`R$ ${formatarValorMonetario(registro.valorLiquido)}`}</>
            </RegistroTabela>
          </LinhaTabela>
        );
      });
    }
  };

  return <>{renderRegistros()}</>;
};

export default RenderRowsTabelaModalVincularDespesasGroupPay;
